import axios from "../../services/axios";

interface GetAllParams {
  query : any;
}

const ExhibitorService = {
  getAll: async ({query}: GetAllParams ) => {
    try {
      const res = await axios.get(`/exhibitors?${query}`);

      return {
        data: res.data.data,
        pagination: res.data.meta.pagination,
      };
    } catch (error) {
      console.error("Error fetching exhibitors:", error);
      throw error;
    }
  },

  update: async (exhibitorId: string, exhibitor:any) => {
    try {
      const response = await axios.put(`/exhibitors/${exhibitorId}`, exhibitor);
      return response.data;
    } catch (error) {
      console.error(`Error updating exhibitor with ID ${exhibitorId}:`, error);
      throw error;
    }
  },
};

export default ExhibitorService;
